import { getAreaConfig, getGlobalConfig } from '../utils/config';

export function useConfig() {
  const { isUS } = getGlobalConfig();
  const { apiBaseUrl } = getAreaConfig();

  return {
    isUS,
    apiBaseUrl,
  };
}
